import {CALL_API} from 'middleware/api';

export const FETCH_BALANCE = 'FETCH_BALANCE';
export const SUCCESS_FETCH_BALANCE = 'SUCCESS_FETCH_BALANCE';
export const FAILURE_FETCH_BALANCE = 'FAILURE_FETCH_BALANCE';

function fetchBalance(data) {
    return {
        type: FETCH_BALANCE,
        [CALL_API]: {
            endpoint: '/api/balance/',
            method: 'post',
            types: [SUCCESS_FETCH_BALANCE, FAILURE_FETCH_BALANCE],
            credentials: true,
            data
        }
    };
}

export function balance(data) {
    return (dispatch) => {
        dispatch(fetchBalance(data));
    };
}



// WEBPACK FOOTER //
// ./js/actions/balance/balanceAction.js